import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { Header2, Header3, Text } from '../../../styles/Components'
import Button from '../../Button'
import { gsColors as c } from '../../../styles/Variables'
import { howToBookSteps } from './data'

const HowToBookWrapper = styled.div`
  width: 100%;
  padding: 72px 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1600px;

  ${mq('max', '768px')} {
    padding: 32px 79px 50px;
  }

  .mobile-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    ${mq('max', '768px')} {
      align-items: flex-start;
      width: auto;
    }

    .how-to-step-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 32px;

      ${mq('max', '768px')} {
        flex-direction: column;
        align-items: flex-start;
      }

      .how-to-step {
        display: flex;
        flex-direction: row;
        margin-bottom: 18px;
      }
    }
  }
`

const HowToBookSection = () => (
  <HowToBookWrapper>
    <div className='mobile-container'>
      <Header2 margin='0 0 24px 0'>
        How to book glam
      </Header2>
      <div className='how-to-step-container'>
        {howToBookSteps.map((s, i) => (
          <div className='how-to-step' key={i}>
            <Header3 margin='0 8px 0 0' color={c.cobalt}>
              0{i + 1}
            </Header3>
            <Text variant='medium'>
              {s}
            </Text>
          </div>
        ))}
      </div>
      <Button large outline color='#000' path='book'>
        Get Started
      </Button>
    </div>
  </HowToBookWrapper>
)

export default HowToBookSection
